import * as ARInvoiceGroupI from "./ARInvoiceGroup";
import * as ExportEClaimFileI from "./ExportEClaimFile";
import * as DownloadSentClaimFileI from "./DownloadSentClaimFile";
import * as ImportLabValuesCalcDFI from "./ImportLabValuesCalcDF";
import * as DoctorFeeSummaryI from "./DoctorFeeSummary";
import * as DoctorFeeReportI from "./DoctorFeeReport";
import * as UploadPatientCoverageI from "./UploadPatientCoverage";
import * as ClaimTaxDocumentI from "./ClaimTaxDocument";
import * as AIPNSendClaimI from "./AIPNSendClaim";
import * as SendClaimResponseFileI from "./SendClaimResponseFile";
import * as CostCenterReceiptI from "./CostCenterReceipt";
import * as SapAccountingReportI from "./SapAccountingReport";
import * as SendClaimDownloadZipFileI from "./SendClaimDownloadZipFile";
import * as BillingPYInterfaceI from "./BillingPYInterface";
import * as TriggerDischargeInterfaceI from "./TriggerDischargeInterface";
import * as DrugTransferInterfaceI from "./DrugTransferInterface";
import * as DrugDispensingInterfaceI from "./DrugDispensingInterface";
import * as OperatingOrderInterfaceI from "./OperatingOrderInterface";
import * as DoctorFeeOrderInterfaceI from "./DoctorFeeOrderInterface";
import * as TriggerInvoiceitemI from "./TriggerInvoiceitem";
import * as LabOrderInterfaceI from "./LabOrderInterface";
import * as ImagingOrderInterfaceI from "./ImagingOrderInterface";
import * as TreatmentOrderInterfaceI from "./TreatmentOrderInterface";
import * as BillingBLInterfaceI from "./BillingBLInterface";
import * as PatientRecordInterfaceI from "./PatientRecordInterface";
import * as DFInterfaceI from "./DFInterface";
import * as EditDivisionSupplyOrderI from "./EditDivisionSupplyOrder";
import * as GenerateOutboundFreezeTimeI from "./GenerateOutboundFreezeTime";
import * as GenerateContinueByDateI from "./GenerateContinueByDate";
import * as GenerateContinueByPlanI from "./GenerateContinueByPlan";
import * as AddNedDrugOrderItemI from "./AddNedDrugOrderItem";
import * as PdfMakeHeaderPreviewI from "./PdfMakeHeaderPreview";

const SequencePattern: {
  [name: string]: { [flavor: string]: { [func: string]: any } };
} = {
  ARInvoiceGroup: {
    default: {
      START: ARInvoiceGroupI.Start,
      IssueInv: ARInvoiceGroupI.IssueInv,
      InvIssued: ARInvoiceGroupI.InvIssued,
    },
  },
  ExportEClaimFile: {
    default: {
      START: ExportEClaimFileI.GetMaster,
      ACTION: ExportEClaimFileI.Action,
    },
  },
  DownloadSentClaimFile: {
    default: {
      START: DownloadSentClaimFileI.GetMaster,
      ACTION: DownloadSentClaimFileI.Action,
    },
  },
  ImportLabValuesCalcDF: {
    default: {
      START: ImportLabValuesCalcDFI.GetMaster,
      Action: ImportLabValuesCalcDFI.Action,
    },
  },
  DoctorFeeSummary: {
    default: {
      START: DoctorFeeSummaryI.Start,
      Create: DoctorFeeSummaryI.Create,
      Fee: DoctorFeeSummaryI.Fee,
      Summary: DoctorFeeSummaryI.Summary,
    },
  },
  DoctorFeeReport: {
    default: {
      START: DoctorFeeReportI.Start,
      Description: DoctorFeeReportI.Description,
      Overview: DoctorFeeReportI.Overview,
      GetReport: DoctorFeeReportI.GetReport,
    },
  },
  UploadPatientCoverage: {
    default: {
      START: UploadPatientCoverageI.GetMaster,
      Action: UploadPatientCoverageI.Action,
    },
  },
  ClaimTaxDocument: {
    default: {
      START: ClaimTaxDocumentI.Start,
      Action: ClaimTaxDocumentI.Action,
    },
  },
  AIPNSendClaim: {
    default: {
      START: AIPNSendClaimI.GetMaster,
      Action: AIPNSendClaimI.Action,
    },
  },
  SendClaimResponseFile: {
    default: {
      START: SendClaimResponseFileI.Start,
      EClaim: SendClaimResponseFileI.EClaim,
      AIPN: SendClaimResponseFileI.AIPN,
    },
  },
  CostCenterReceipt: {
    default: {
      START: CostCenterReceiptI.Start,
      Action: CostCenterReceiptI.Action,
    },
  },
  SapAccountingReport: {
    default: {
      START: SapAccountingReportI.Start,
      Action: SapAccountingReportI.Action,
    },
  },
  SendClaimDownloadZipFile: {
    default: {
      START: SendClaimDownloadZipFileI.GetMaster,
      Action: SendClaimDownloadZipFileI.Action,
    },
  },
  BillingPYInterface: {
    default: {
      START: BillingPYInterfaceI.Start,
      Action: BillingPYInterfaceI.Action,
    },
  },
  TriggerDischargeInterface: {
    default: {
      START: TriggerDischargeInterfaceI.Start,
      Action: TriggerDischargeInterfaceI.Action,
    },
  },
  DrugTransferInterface: {
    default: {
      START: DrugTransferInterfaceI.Start,
      Action: DrugTransferInterfaceI.Action,
    },
  },
  DrugDispensingInterface: {
    default: {
      START: DrugDispensingInterfaceI.Start,
      Action: DrugDispensingInterfaceI.Action,
    }
  },
  OperatingOrderInterface: {
    default: {
      START: OperatingOrderInterfaceI.Start,
      Action: OperatingOrderInterfaceI.Action,
    },
  },
  DoctorFeeOrderInterface: {
    default: {
      START: DoctorFeeOrderInterfaceI.Start,
      Action: DoctorFeeOrderInterfaceI.Action,
    },
  },
  TriggerInvoiceitem: {
    default: {
      START: TriggerInvoiceitemI.Start,
      Action: TriggerInvoiceitemI.Action,
    },
  },
  LabOrderInterface: {
    default: {
      START: LabOrderInterfaceI.Start,
      Action: LabOrderInterfaceI.Action,
    },
  },
  ImagingOrderInterface: {
    default: {
      START: ImagingOrderInterfaceI.Start,
      Action: ImagingOrderInterfaceI.Action,
    },
  },
  TreatmentOrderInterface: {
    default: {
      START: TreatmentOrderInterfaceI.Start,
      Action: TreatmentOrderInterfaceI.Action,
    },
  },
  BillingBLInterface: {
    default: {
      START: BillingBLInterfaceI.Start,
      Action: BillingBLInterfaceI.Action,
    },
  },
  PatientRecordInterface: {
    default: {
      START: PatientRecordInterfaceI.Start,
      Action: PatientRecordInterfaceI.Action,
    },
  },
  DFInterface: {
    default: {
      START: DFInterfaceI.Start,
      Action: DFInterfaceI.Action,
    },
  },
  EditDivisionSupplyOrder: {
    default: {
      START: EditDivisionSupplyOrderI.Start,
      Action: EditDivisionSupplyOrderI.Action,
    },
  },
  GenerateOutboundFreezeTime: {
    default: {
      START: GenerateOutboundFreezeTimeI.Start,
      Action: GenerateOutboundFreezeTimeI.Action,
    },
  },
  GenerateContinueByDate: {
    default: {
      START: GenerateContinueByDateI.Start,
      Action: GenerateContinueByDateI.Action,
    },
  },
  GenerateContinueByPlan: {
    default: {
      START: GenerateContinueByPlanI.Start,
      Action: GenerateContinueByPlanI.Action,
    },
  },
  AddNedDrugOrderItem: {
    default: {
      START: AddNedDrugOrderItemI.Start,
      Action: AddNedDrugOrderItemI.Action,
    },
  },
  PdfMakeHeaderPreview: {
    default: {
      START: PdfMakeHeaderPreviewI.Start,
      Action: PdfMakeHeaderPreviewI.Action,
    },
  },
};

export default SequencePattern;
